<section class="member-follow-up-page">
  <header class="member-follow-up-page__header">
    <button mat-icon-button type="button" aria-label="Volver a la unidad" [routerLink]="['/units', unitId]">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div>
      <h1>Miembros de {{ unitName || '...' }}</h1>
      <p>Seguimiento de Asistencia Espiritual</p>
    </div>
  </header>

  <mat-card class="member-follow-up-page__card table-surface-card">
    <mat-card-content>
      <app-table-surface
        tableId="member-follow-up"
        title="Seguimiento de miembros"
        titleIcon="monitor_heart"
        titleInfoTooltip="Este listado muestra únicamente miembros activos de la unidad."
        [columns]="columns"
        [data]="items"
        [isLoading]="isLoading"
        [enableRowHover]="false"
        [paginationConfig]="paginationConfig"
        [showPageSizeSelector]="true"
        [pageSizeOptions]="[10, 25, 50, 100]"
        [noDataMessage]="'No hay miembros que coincidan con la búsqueda o los filtros aplicados.'"
        [cellTemplate]="cellTemplate"
        [activeFilters]="activeFilterChips"
        [enableSearch]="true"
        [enableFilter]="true"
        [enableSort]="true"
        [enableColumnVisibility]="true"
        [enableDensity]="true"
        [sortState]="currentSort"
        [initialSort]="currentSort"
        searchPlaceholder="Buscar miembro..."
        (searchInput)="onSearchInput()"
        (searchChange)="onSearch($event)"
        (sortChange)="onSortChange($event)"
        (toolbarSortChange)="onSortChange($event)"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (filterRemove)="onFilterRemove($event)">
        <div filterPanel class="member-follow-up-page__filters" [formGroup]="filterForm">
          <app-age-status-multi-select-filter formControlName="ageStatuses"></app-age-status-multi-select-filter>
          <app-person-multi-select-filter
            class="member-follow-up-page__responsible-priest-filter"
            formControlName="responsiblePriestIds"
            label="Pastor de hogar"
            [searchPeople]="searchResponsiblePriests"
            (selectedPeopleChange)="onResponsiblePriestSelectionChange($event)"></app-person-multi-select-filter>
          <div class="member-follow-up-page__filter-field">
            <span class="member-follow-up-page__filter-label">Atención en el hogar</span>
            <mat-form-field appearance="fill" subscriptSizing="dynamic">
              <mat-select formControlName="isHomeAttended" aria-label="Atención en el hogar">
                <mat-option value="all">Todos</mat-option>
                <mat-option *ngFor="let option of homeAttendanceOptions" [value]="option.value">{{ option.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </app-table-surface>
    </mat-card-content>
  </mat-card>

  <ng-template #cellTemplate let-column="column" let-row="row">
    <a *ngIf="column === 'fullName'" class="member-follow-up-page__member" [routerLink]="['/people', row.id]">{{ row.fullName }}</a>
    <span *ngIf="column === 'communityName'">{{ row.communityName }}</span>
    <span *ngIf="column === 'age'" class="member-follow-up-page__age">
      <span>{{ row.age ?? '-' }}</span>
      <span *ngIf="row.ageStatus" class="member-follow-up-page__secondary-status">{{ getAgeStatusLabel(row.ageStatus) }}</span>
    </span>
    <span *ngIf="column === 'responsiblePriest'" class="member-follow-up-page__responsible-priest">
      <app-member-reference
        *ngIf="row.responsiblePriestName; else noResponsiblePriest"
        [personId]="row.responsiblePriestId"
        [name]="row.responsiblePriestName"></app-member-reference>
      <ng-template #noResponsiblePriest>-</ng-template>
    </span>
    <span *ngIf="column === 'isHomeAttended'">{{ row.isHomeAttended ? 'Sí' : 'No' }}</span>
    <span *ngIf="column === 'lastAttendance'">{{ formatDate(row.lastAttendanceAt) }}<span *ngIf="getDaysSince(row.lastAttendanceAt) !== null" class="member-follow-up-page__secondary-status">{{ getDaysSince(row.lastAttendanceAt) }} días</span></span>
    <span *ngIf="column === 'lastSpiritualAssistanceVisit'">{{ formatDate(row.lastSpiritualAssistanceVisitDate) }}<span *ngIf="getDaysSince(row.lastSpiritualAssistanceVisitDate) !== null" class="member-follow-up-page__secondary-status">{{ getDaysSince(row.lastSpiritualAssistanceVisitDate) }} días</span></span>
    <span *ngIf="column === 'lastHolyCommunion'">{{ formatDate(row.lastHolyCommunionDate) }}<span *ngIf="getDaysSince(row.lastHolyCommunionDate) !== null" class="member-follow-up-page__secondary-status"><span [class.member-follow-up-page__secondary-status-value--warning]="row.isHomeAttended && isHolyCommunionOverdue(row.lastHolyCommunionDate)">{{ getDaysSince(row.lastHolyCommunionDate) }} días</span></span></span>
  </ng-template>
</section>
